import { useTranslation } from "react-i18next";
import { useOperationsMap } from "../OperationsMapProvider";
import { Button, Stack, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useCallback } from "react";
import DispatchCompactToolbar from "../../dispatch/common/DispatchCompactToolbar";
import TaskList from "../../dispatch/common/TaskList";
import { useDispatch } from "../../dispatch/providers/DispatchProvider";
import { useDevice } from "../../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: theme.spacing(1),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(6)
    },
  })
);

export default function ActiveTasksPanel() {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { slim } = useDevice();

  const {
    showLoading,
    filteredActiveTasks,
    activeTasks,
    resetFilter,
    orderTasksBy,
  } = useDispatch();

  const {
    dispatchLayerHoverId,
    operationsMap,
    openTaskDialog,
  } = useOperationsMap();

  const onItemMouseEnter = useCallback((_, task) => {
    operationsMap?.getPlugin("dispatch")?.setHighlightHighContrast(task.id);
  }, [operationsMap]);

  const onItemMouseLeave = useCallback(() => {
    operationsMap?.getPlugin("dispatch")?.setHighlightHighContrast("none");
  }, [operationsMap]);

  const onItemClicked = useCallback((ev, task) => {
    ev.preventDefault();
    openTaskDialog(task.id);
  }, [openTaskDialog]);

  const showClearFilters = activeTasks.length > filteredActiveTasks.length

  return (
    <Stack spacing={1} className={classes.root}>
      <DispatchCompactToolbar popper searchDefaultOpen />

      <Typography variant="body" color="textSecondary">
        {showClearFilters ? `Viser ${filteredActiveTasks.length} av ${activeTasks.length}` : `${activeTasks.length} totalt`}
        {showClearFilters ? <Button color="info" onClick={resetFilter}>(nullstill filter)</Button> : null}
      </Typography>

      <TaskList
        cards
        orderTasksBy={orderTasksBy}
        tasks={filteredActiveTasks}
        showLoading={showLoading}
        highlightTaskById={dispatchLayerHoverId}
        emptyStateTitle={t("dispatch:activeTasks:emptyStateTitle")}
        emptyStateDescription={t("dispatch:activeTasks:emptyStateDescription")}
        emptyStateFilteredDescription={t("dispatch:activeTasks:emptyStateFilteredDescription")}
        onItemClicked={onItemClicked}
        onItemMouseEnter={onItemMouseEnter}
        onItemMouseLeave={onItemMouseLeave}
        slim={slim}
      />
    </Stack>
  );
}
